module.exports = __webpack_public_path__ + "img/gywm.46722b97.png";